'use client'

import dynamic from 'next/dynamic'

// Keep Web Vitals reporting out of server rendering and load it on the client.
const WebVitals = dynamic(
  () => import('@/app/_components/WebVitals').then((mod) => mod.WebVitals),
  { ssr: false }
)

export function DeferredWebVitals() {
  return <WebVitals />
}
